module.exports = __webpack_public_path__ + "static/media/74.97ef94f3.jpg";